import { Table } from "@/features/Table";
import { type A5StaticDatum, porfolios_columns } from "./columns";
import {
  type FilterA5StaticDatumsSchema,
  FilterA5StaticDatums,
} from "./filter";
import { useTranslation } from "react-i18next";

const client = "a5";
const table_name = "a5_static_data";

export const A5StaticDatumsTable = () => {
  const { t } = useTranslation();

  return (
    <Table<A5StaticDatum, FilterA5StaticDatumsSchema>
      label={t(`${table_name}.title`, { ns: "tables", defaultValue: "Actifs" })}
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterA5StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
